import {onDomReady} from "../../components/dynamic/observer";
import {Navigation, Swiper} from 'swiper';
import '../../../node_modules/swiper/swiper.scss';

function init() {
    const compareSliderContainers = document.querySelectorAll('[data-compare-slider-container]');
    if (!compareSliderContainers) {
        return;
    }

    compareSliderContainers.forEach((compareSliderContainer) => {
        const compareSliderElement = compareSliderContainer.querySelector('[data-compare-slider]');
        const compareStickySliderElement = compareSliderContainer.querySelector('[data-compare-sticky-slider]');
        if (!compareSliderElement || !compareStickySliderElement) {
            return;
        }

        const leftArrow = compareSliderContainer.querySelector('[data-compare-slider-left]');
        const rightArrow = compareSliderContainer.querySelector('[data-compare-slider-right]');

        const slider = new Swiper(compareSliderElement, {
            modules: [Navigation],
            slidesPerView: "auto",
            spaceBetween: 28,
            navigation: {
                prevEl: leftArrow,
                nextEl: rightArrow,
            },
        });

        const stickySlider = new Swiper(compareStickySliderElement, {
            modules: [Navigation],
            slidesPerView: "auto",
            spaceBetween: 28,
        });

        slider.on('slideNextTransitionStart', () => {
            stickySlider.slideTo(slider.realIndex);
        });

        slider.on('slidePrevTransitionStart', () => {
            stickySlider.slideTo(slider.realIndex);
        });
    })
}

onDomReady(init);